module.exports = __webpack_public_path__ + "img/ideaBuddy-color.3ecdb560.svg";